import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=361921f7&scoped=true&"
import script from "./Dashboard.ts?vue&type=script&lang=ts&"
export * from "./Dashboard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361921f7",
  null
  
)

export default component.exports
import {QTabs,QTab,QBadge,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QTabs,QTab,QBadge,QTabPanels,QTabPanel}, component.options.components || {})
